// Global namespace
window.RS = window.RS || {};

// all utilities
RS.Utils = RS.Utils || {};

// Basket Module
RS.Modules = RS.Modules || {};



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/universalheader/base.js
// module id = 25
// module chunks = 2 5 8